var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillJobactiveicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H9.5V12H0.5V0ZM8.75 11.25V0.75H1.25V11.25H8.75ZM8 3V3.75H5V3H8ZM8 6V6.75H5V6H8ZM8 9V9.75H5V9H8ZM4.51367 2.51367L3.125 3.90234L2.11133 2.88867L2.63867 2.36133L3.125 2.84766L3.98633 1.98633L4.51367 2.51367ZM4.51367 5.51367L3.125 6.90234L2.11133 5.88867L2.63867 5.36133L3.125 5.84766L3.98633 4.98633L4.51367 5.51367ZM4.51367 8.51367L3.125 9.90234L2.11133 8.88867L2.63867 8.36133L3.125 8.84766L3.98633 7.98633L4.51367 8.51367Z",
    fill: "#D12232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillJobactiveicon);
export default __webpack_public_path__ + "static/media/skill_jobactiveicon.9ee2ca10360fd30145018d047c6d9d1c.svg";
export { ForwardRef as ReactComponent };